import React, { Component } from "react";
import AddClientPayment from "../ClientPayment/AddClientPayment";
import ViewClientPayment from "../ClientPayment/ViewClientPayment";
import setTitle from "../../../helpers/TitleComponent";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { API_URL } from "../../../constants";
import { isEmpty } from "../../../helpers/index";

const axios = require("axios");

export default class ClientPayment extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.OnEditClick = this.OnEditClick.bind(this);
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.formClear = this.formClear.bind(this);
    this.childRef = React.createRef();
    this.state = {
      user: {
        clientid: null,
        amount: null,
        transactiontype: null,
        remarks: "",
        entrydate: new Date(),
        createdby: getCookie("username"),
      },
      rules: {
        clientid: ["required"],
        transactiontype: ["required"],
        amount: ["required"],
      },
      transactionType: [
        { value: "debit", text: "Debit" },
        { value: "credit", text: "Credit" },
      ],
      operation: "Add",
      selected: {},
      permissions: [],
      clientsList: [],
    };
  }

  componentDidMount() {
    var data = getCookie("permission");
    this.setState(
      {
        permissions: JSON.parse(data),
      },
      function () {
        setTitle("Client Payment");
        this.getClientsForComboBox();
      }
    );
  }

  async getClientsForComboBox() {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/allclientinfo`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            this.setState({
              clientsList: response.data.object,
            });
          }
        })
        .catch(function (error) {});
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientsForComboBox();
      }
    }
  }

  formClear() {
    let user = {
      clientid: null,
      amount: null,
      transactiontype: null,
      remarks: "",
      entrydate: new Date(),
      createdby: getCookie("username"),
    };
    this.setState(
      {
        user: user,
        operation: "Add",
      },
      function () {
        this.childRef.current.validate((errors) => {});
      }
    );
  }

  OnEditClick() {
    var rules = this.state.rules;
    //console.log("this.state.selected", this.state.selected);
    if (this.state.selected != null) {
      this.setState({
        rules: rules,
        user: this.state.selected,
        operation: "Update",
      });

      const timer = setTimeout(() => {
        this.childRef.current.validate((errors) => {});
      }, 100);
      return () => clearTimeout(timer);
    }
  }

  onSelectionChange(selectedRow) {
    if (selectedRow) {
      selectedRow.entrydate = new Date(selectedRow.entrydate);
    }
    this.setState({
      selected: selectedRow,
    });
  }

  handleChange(name, value) {
    let user = Object.assign({}, this.state.user);
    user[name] = value;
    this.setState({ user: user });
  }

  render() {
    const { permissions } = this.state;
    return (
      <div className='container-fluid'>
        <div className='row'>
          {permissions.includes("client-payment-create") ? (
            <div className='col-5 '>
              <AddClientPayment
                userFields={this.state.user}
                clientsList={this.state.clientsList}
                transactionType={this.state.transactionType}
                validationRules={this.state.rules}
                handleChange={this.handleChange}
                operation={this.state.operation}
                ref={this.childRef}
                formClear={this.formClear}
              />
            </div>
          ) : (
            ""
          )}
          {permissions.includes("client-payment-view") ? (
            <div className='col-7 '>
              <ViewClientPayment
                selectedRow={this.state.selected}
                OnEditClick={this.OnEditClick}
                onSelectionChange={this.onSelectionChange}
                permissions={permissions}
                clientsList={this.state.clientsList}
              />
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
